import { Button, Center, Icon, TFCard, TFEmptyStateMessage, useMantineTheme } from '@tf/ui';

import type { MouseEventHandler } from 'react';
import React from 'react';

interface SimplePageProps {
	icon?: React.ReactElement;
	title?: string;
	description?: string;
	action?: {
		icon: React.ReactElement;
		label: string;
		onClick: MouseEventHandler;
	};
}

export const SimplePage: React.FC<SimplePageProps> = ({
	icon = <Icon.IconUnlink />,
	title = 'Unexpected error',
	description,
	action,
}) => {
	const theme = useMantineTheme();

	return (
		<Center h="100vh" p="1rem" bg={theme.white}>
			<TFCard
				sx={({ breakpoints }) => ({
					width: '100%',
					maxWidth: breakpoints.md,
				})}
			>
				<TFEmptyStateMessage
					isLarge={true}
					icon={icon}
					title={title}
					description={description}
					primaryAction={
						action && (
							<Button
								leftSection={React.cloneElement(
									// react 19 types .props as unknown; cloneElement merges the
									// existing props itself, so only the override is passed.
									action.icon as React.ReactElement<{ size?: number }>,
									{ size: 24 },
								)}
								variant="light"
								size="md"
								h={48}
								fz={16}
								fw={500}
								onClick={action.onClick}
							>
								{action.label}
							</Button>
						)
					}
				/>
			</TFCard>
		</Center>
	);
};
